<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },

  canClear: {
    type: Boolean,
    default: false,
  },
  searchable: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: "Select a checklist",
  },
});

const emit = defineEmits(["update:modelValue"]);

const appUserDataStore = useAppUserData();
const { appUser } = storeToRefs(appUserDataStore);

const userChecklistStore = useUserChecklistsStore();
const { checklists } = storeToRefs(userChecklistStore);

const key = ref(Date.now());

watch(checklists, () => {
  console.log("checklists changed", checklists.value);
  key.value = Date.now();
});

const selectKey = computed(() => {
  return `${props.modelValue ?? "n/a"}-${key.value}`;
});

const sortedChecklists = computed(() => {
  return useSortChecklists(checklists.value);
});
</script>

<template>
  <BaseSelectInput
    :key="selectKey"
    :options="sortedChecklists"
    value-prop="id"
    label="title"
    :model-value="modelValue"
    :searchable="searchable"
    :can-clear="canClear"
    :placeholder="placeholder"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #empty-results>
      <BaseIconCircleDashed class="text-medium text-input-1 mr-2" />
      <span class="text-input-1 text-medium flex flex-row items-center">
        Can't find a checklist?
        <NuxtLink to="/configure/curriculum" target="_blank">
          <span class="ml-2 text-primary-default hover:underline">
            Configure here.
          </span>
        </NuxtLink>
      </span>
    </template>
  </BaseSelectInput>
</template>

<style scoped></style>
